import { Card, Dropdown } from "@fanduel/og-fe-library";
import cx from "classnames";
import Link from "next/link";
import { useRouter } from "next/router";
import { RACING_RACE_SELECTED } from "@/constants/amplitude";
import { Hr_Race } from "@/graphql/gql/graphql";
import { useAmplitude } from "@/utils/hooks/useAmplitude";
import styles from "./raceControls.module.scss";

interface RaceSelectionProps {
  races: Hr_Race[];
}

const RaceSelection = ({ races }: RaceSelectionProps) => {
  const { query, push } = useRouter();
  const { track, race: raceNumber, tab } = query;
  const raceInt = Number.parseInt(raceNumber?.toString() ?? "", 10) || 1;
  const { logAmplitudeEvent } = useAmplitude();
  const tabQuery = tab ? `&tab=${tab}` : "";
  const selected = raceInt && races.length < raceInt ? 0 : raceInt - 1;

  return (
    <>
      <Card
        rounded="sm"
        className={cx(
          styles.raceList,
          races.length > 12 ? styles.isOversized : "",
          races.length > 20 ? styles.isVeryOversized : ""
        )}
        variant="elevation"
        elevation="mid"
      >
        {races.map((race) => (
          <div
            className={cx(
              styles.link,
              race.number === raceNumber && styles.active
            )}
            key={race.number}
          >
            <Link
              onClick={() => {
                logAmplitudeEvent(RACING_RACE_SELECTED, {
                  Module: "race_selector",
                  "Track Name": track?.[1] ?? "unknown track name",
                  "Item Selected": race.number ?? "unknown number",
                });
              }}
              href={`/horse-racing/picks/${track?.[0]}/${track?.[1]}?race=${race.number}${tabQuery}`}
            >
              <span>{`R${race.number}`}</span>
            </Link>
          </div>
        ))}
      </Card>
      <div className={styles.raceDropdown}>
        {races.length > 0 ? (
          <Dropdown
            variant="standard"
            title="Race"
            setSelected={() => {}}
            onChange={(index) => {
              logAmplitudeEvent(RACING_RACE_SELECTED, {
                Module: "race_selector",
                "Track Name": track?.[1] ?? "unknown track name",
                "Item Selected": index + 1,
              });
              push(
                `/horse-racing/picks/${track?.[0]}/${track?.[1]}?race=${index + 1}`
              );
            }}
            selected={selected}
            options={races.map((race) => ({
              ...race,
              label: `Race ${race.number}`,
            }))}
          />
        ) : (
          ""
        )}
      </div>
    </>
  );
};

export default RaceSelection;
